var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("scrollTop", [_c("i", { staticClass: "icon-fa icon-fa-arrow-up" })]),
      _vm._v(" "),
      _c("table", { staticClass: "table table-striped table-hover table-sm" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.data, function (record, timestamp, i) {
            return _c(
              "tr",
              {
                class: {
                  tr_red:
                    _vm.remain[timestamp] && _vm.remain[timestamp].remain < 0,
                  tr_green:
                    _vm.remain[timestamp] && _vm.remain[timestamp].remain === 0,
                },
              },
              [
                _c("td", [_vm._v(_vm._s(i + 1))]),
                _vm._v(" "),
                record.type === "order"
                  ? [
                      _c("td"),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            record.data.type_id === 2 ? "Возврат" : "Продажа"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n          " +
                            _vm._s(record.data.id) +
                            "\n          "
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-xs btn-info pull-left mr-2",
                            on: {
                              click: function ($event) {
                                return _vm.orderToEdit(record.data.id)
                              },
                            },
                          },
                          [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(record.date))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            !_vm.storeId
                              ? _vm.$AllCities[record.data.city_id].name
                              : null
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td"),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            (_vm.remain[timestamp] &&
                              _vm.remain[timestamp].qty) ||
                              0
                          )
                        ),
                      ]),
                    ]
                  : [
                      _c("td", [
                        _vm.getTitleByRecord(record).in
                          ? _c("i", {
                              staticClass:
                                "icon-fa icon-fa-plus-square pointer click",
                              on: {
                                click: function ($event) {
                                  return _vm.showInvoice(record.data.id)
                                },
                              },
                            })
                          : _c("i", {
                              staticClass:
                                "icon-fa icon-fa-minus-square pointer click",
                              on: {
                                click: function ($event) {
                                  return _vm.showInvoice(record.data.id)
                                },
                              },
                            }),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.getTitleByRecord(record).title)),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(record.data.id))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(record.date))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            record.data.store_in === +_vm.storeId
                              ? (_vm.$AllStores[record.data.store_out] &&
                                  _vm.$AllStores[record.data.store_out]
                                    .title) ||
                                  record.data.store_out
                              : (_vm.$AllStores[record.data.store_in] &&
                                  _vm.$AllStores[record.data.store_in].title) ||
                                  record.data.store_in
                          ) + "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            record.data.store_in === +_vm.storeId ||
                              record.data.store_out === null
                              ? (_vm.remain[timestamp] &&
                                  _vm.remain[timestamp].qty) ||
                                  0
                              : null
                          ) + "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            record.data.store_out === +_vm.storeId ||
                              record.data.store_in === 1
                              ? (_vm.remain[timestamp] &&
                                  _vm.remain[timestamp].qty) ||
                                  0
                              : null
                          ) + "\n        "
                        ),
                      ]),
                    ],
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      (_vm.remain[timestamp] && _vm.remain[timestamp].remain) ||
                        0
                    )
                  ),
                ]),
              ],
              2
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("h5", [
        _vm._v("Итого: "),
        _c("strong", [_vm._v(_vm._s(_vm.totalRemain))]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Тип")]),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th", [_vm._v("Откуда/куда")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дт")]),
        _vm._v(" "),
        _c("th", [_vm._v("Кр")]),
        _vm._v(" "),
        _c("th", [_vm._v("Итог")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }